import React, {useState, useEffect, useContext} from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import MuiAlert from '@material-ui/lab/Alert';
import { UserContext } from 'context/userContext'
import db from 'firebase/dbConfig'

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  alert: {
    marginTop: 20,
    textAlign: 'justify',
  },
  infoIcon: {
    marginRight: 20,
  },
  white: {
    color: 'white',
  }
};

const useStyles = makeStyles(styles);

export default function Notifications() {
  const classes = useStyles();
  const [notes, setNotes] = useState([])
  const {isPro, recordsCount, userProfile} = useContext(UserContext)

  useEffect(() => {
    db.collection('notifications').onSnapshot(snapshot => {
      const allRecords = snapshot.docs.map(doc => ({
        data: doc.data().message
      }));
      setNotes(allRecords)
    })
  },[])

  return (
    <Card>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>Avisos</h4>
        <p className={classes.cardCategoryWhite}>
          Confira aqui as novidades do www.avaliacaopreanestesica.com
        </p>
      </CardHeader>
      <CardBody>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            {notes.map( (note, index) => (
              <MuiAlert key={index+note} className={classes.alert} elevation={6} variant="filled" severity="info">
                {note.data}
              </MuiAlert>
            ))}
            { !userProfile &&  ( <MuiAlert className={classes.alert} elevation={6} variant="filled" severity="info">
                            É muito importante que seu perfil seja preenchido! Clique no item "Perfil" no menu lateral.
                          </MuiAlert>
            )}
            { !isPro &&  ( <MuiAlert className={classes.alert} elevation={6} variant="filled" severity="info">
                            Assine o Plano Pro e desfrute do uso ilimitado de todas as nossas funcionalidades.
                          </MuiAlert>
            )}
            { (!isPro && recordsCount > 3 && recordsCount < 20) && ( <MuiAlert className={classes.alert} elevation={6} variant="filled" severity="info">
                            Você ainda tem {20 - recordsCount} fichas na sua cota gratuita. Aproveite!
                          </MuiAlert>
            )}
            { (!isPro && recordsCount >= 20) &&  ( <MuiAlert className={classes.alert} elevation={6} variant="filled" severity="error">
                            Você excedeu sua cota gratuita. Assine o PRO agora para realizar atendimentos ilimitados.
                          </MuiAlert>
            )}
          </GridItem>
          <br/>
          <br/>
          <br/>
          <div className={classes.white}>.</div>
        </GridContainer>
      </CardBody>
    </Card>
  );
}
